import * as actions from './twoFAconstants';
import axios from 'axios';
import { asyncActionStart, asyncActionFinish, asyncActionError } from '../async/asyncActions';
import { toastr } from 'react-redux-toastr';
import { closeModal } from '../modals/modalActions';
import API from '../../APIconfig';
import history from '../../app/common/util/history';

export const verifyTwoFALogin = (otp, userDetails, csrfRequestIdentifier) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Verifying TwoFA . . .', false, 'verifytwofa'));

      const user = await axios({
        url: API.twoFa.verify.url,
        method: API.twoFa.verify.method,
        headers: {
          csrfRequestIdentifier,
          'Content-Type': 'application/json',
          fcChannel: API.fcChannel,
        },
        data: {
          fcChannelId: 11,
          increaseTokenSession: true,
          otp,
          otpId: userDetails.otpId,  
          platformType: "WEB",
          purpose: "VERIFY_OTP_FOR_TWOFA",
        },
        credentials: API.auth.isLoggedIn.credentials,
        mode: 'cors',
      });

      dispatch({
        type: actions.VERFIY_TWO_FA_LOGIN,
        payload: user,
      });

      dispatch(closeModal());
      dispatch(asyncActionFinish());      
      history.push('/accounts/');     
    } 
    catch (error) {
      console.log(error);
      toastr.error('Failed to get user details. ' + error);
      dispatch(asyncActionError());   
    }
  };
};


export const generateTwoFaOtp = (otpId, csrfRequestIdentifier) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Re-sending OTP...', false, 'generatetwofaotp'));

      const user = await axios({
        url: API.twoFa.generateOTP.url,
        method: API.twoFa.generateOTP.method,
        headers: {
          csrfRequestIdentifier,
          'Content-Type': 'application/json',
          fcChannel: API.fcChannel,
        },
        data: {
          otpId,
          otpThroughCall: false,
          platformType: "WEB",
          twoFA: true,
        },
        credentials: API.auth.isLoggedIn.credentials,
        mode: 'cors',
      });

      dispatch({
        type: actions.GENERATE_TWO_FA_OTP,
        payload: user,
      });

      //Hiding Re-send link if otp is successfully generated
      dispatch(changeResendStatus(false));
      dispatch(asyncActionFinish());
    }
    catch (error) {
      console.log(error);
      toastr.error('Failed to generate OTP ' + error);

      //Showing Re-send link if otp generation encounters any error
      dispatch(changeResendStatus(true));
      dispatch(asyncActionError());
    }
  };
};


export const changeResendStatus = (resendStatusFlag) => {
  return async dispatch => {
    dispatch({
      type: actions.CHANGE_RESEND_STATUS,
      payload: {
        showResend: resendStatusFlag
      }
    });
  }
}
